import createAction from '../services/create-action';
export var SET_BLOG_DATA = 'appData/SET';
export var setAppData = createAction(SET_BLOG_DATA);
